export default __webpack_public_path__ + "static/media/005.4cc5e75f.jpg";